import { render, staticRenderFns } from "./AddRolePage.vue?vue&type=template&id=4687cdfa&"
import script from "./AddRolePage.vue?vue&type=script&lang=js&"
export * from "./AddRolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports